import Swiper from '../libs/swiper/core/core'
import { SGPlugin } from '../common/SGPlugins'
import { prefersReducedMotion, sgVersion } from '../common/helpers'

const moduleAddress = {
  'Pagination': 'pagination/pagination',
  'Autoplay': 'autoplay/autoplay',
  'Navigation': 'navigation/navigation',
  'Mousewheel': 'mousewheel/mousewheel'
}

// noinspection JSUnusedGlobalSymbols
export default async (elements: NodeListOf<HTMLElement & {
  swiper?: Swiper
}>) => {
  for (let element of elements) {
    const options = SGPlugin.getElementOptions<{
      config: string
    }>(element, 'swiper')
    if (!options.config) {
      return
    }
    const config = JSON.parse(options.config)

    if (config.modules) {
      const modules = config.modules
      delete (config.modules)

      for (let mod of modules) {
        const { default: Module } = await import(`/dist/js/libs/swiper/modules/${moduleAddress[mod]}.js?${sgVersion()}`)
        Swiper.use([Module])
      }
    }

    if (config.pagination?.renderBullet) {
      const functionText = config.pagination.renderBullet;
      config.pagination.renderBullet = (index: number, className: string) => {
        return eval(functionText)(index, className)
      }
    }

    if (config.on) {
      for (let event in config.on) {
        const functionText = config.on[event];
        config.on[event] = (event: Event) => {
          eval(functionText)(event)
        }
      }
    }

    if (prefersReducedMotion()) {
      if (config.autoplay) {
        config.autoplay = false
      }

      if (config.speed) {
        config.speed = 0
      }
    }

    const imgs = Array.from(element.querySelectorAll<HTMLImageElement>('img:not([loading="lazy"])'))

    const checkInit = () => {
      if (imgs.filter(img => !img.complete).length === 0) {
        element.swiper = new Swiper(element, config)
      }
    }

    for (let key in imgs) {
      const img = imgs[key]
      img.onerror = () => {
        checkInit()
      }
      img.onload = () => {
        checkInit()
      }
    }

    checkInit()
  }
}
